export const TranslationKey = 'chat';
